var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCheck2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12 22c5.5228 0 10-4.4772 10-10 0-5.52285-4.4772-10-10-10-5.52285 0-10 4.47715-10 10 0 5.5228 4.47715 10 10 10zm5.7521-13.33614c.1365-.18526.097-.4461-.0883-.58261-.1852-.1365-.4461-.09698-.5826.08828l-5.5761 7.56767-3.82813-3.0625c-.17969-.1438-.4419-.1147-.58565.065s-.11462.4419.06507.5857l4.16671 3.3333c.0885.0708.2021.1025.3145.0878.1124-.0148.2139-.0747.2812-.166z",
    fill: "#17a680",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCheck2);
export default __webpack_public_path__ + "static/media/ico_check_2.ddab200f18283712b66651b63dd980e4.svg";
export { ForwardRef as ReactComponent };